// Human-readable byte formatting, shared by every surface that shows a photo
// or upload size to the tasker (Card #3492) -- the pending-sync queue, the
// survey upload progress list, and My Photos' batch-upload rows. Switches
// units at a sensible threshold (B -> KB -> MB) rather than always showing
// KB, which reads awkwardly for a compressed photo's near-1MB-and-up sizes.
//
// This is deliberately distinct from field_image_compressor.js's private
// _kb() helper, which stays as-is for its own compression-ladder console
// logging (a precise KB figure is more useful there than a rounded MB one).
export function formatBytes(bytes) {
  if (bytes == null || Number.isNaN(bytes)) return ""
  if (bytes < 1024)    return `${bytes} B`
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / 1048576).toFixed(1)} MB`
}
